import { useSitesByCompanyId } from "./data/useSitesByCompanyId";
import { LOCALSTORAGE_KEYS } from "./shared/constants";
import { useEffect, useState } from "react";
import { Region } from "./shared/interfaces/Region";
import { SiteDropdown } from "./SiteDropdown";

interface Props {
  companyId?: number | undefined;
  customerId?: number | undefined;
  onSiteChange: (company: string) => void;
  showLabel?: boolean;
}

const siteStorageKey = LOCALSTORAGE_KEYS.site;

export function PersistedSiteDropdown(props: Props) {
  const { companyId, customerId, onSiteChange } = props;

  const sites = useSitesByCompanyId(companyId);

  const [selectedSiteName, setSelectedSiteName] = useState<string | undefined>();

  useEffect(() => {
    const siteName = localStorage.getItem(siteStorageKey);
    const storedSite = sites.data?.find((site: Region) => site.name === siteName);
    if (storedSite && selectedSiteName !== storedSite.name) {
      storedSite && setSelectedSiteName(storedSite.name);
      storedSite && onSiteChange(storedSite.name);
    }
  }, [sites.data, onSiteChange, selectedSiteName]);

  const handleChange = (site: string) => {
    localStorage.setItem(siteStorageKey, site);
    localStorage.removeItem(LOCALSTORAGE_KEYS.hvSubstation);
    setSelectedSiteName(site);
    onSiteChange(site);
  };

  return (
    <SiteDropdown
      companyId={companyId}
      customerId={customerId}
      selectedSiteName={selectedSiteName}
      onSiteChange={handleChange}
      showLabel
      showClear={true}
    />
  );
}
